import  { useAuthService } from '../composables/useAuthService'

export default defineNuxtRouteMiddleware(async (to, from) => {

    const { user, isAuthenticated } = useAuthService();

    if (to.path.includes('/cycles/add') || to.path.includes('/ladders/add') || to.path.includes('/leagues/add') || to.path.includes('/divisions/add')) {
        // Remove '/add' and append the query parameter
        const newPath = to.path.replace('/add', '');
        return navigateTo(`${newPath}?action=create`);
    }
    if(to.fullPath.includes('/cycles?action=create')) {
        // Remove '?action=create' and append '/add'
        const newPath = to.fullPath.replace('/cycles?action=create', '');
        return navigateTo(`${newPath}?new=true`);
    }
    if(to.path.includes('/dashboard/true')){
        const newPath = to.path.replace('/dashboard/true', '');
        return navigateTo(`${newPath}?logo=true`);
    }
    if (from.name === 'Chat' && to.name !== 'Chat' && (from.query.conversationId || from.query.type)) {
        // If query parameters are already cleared, prevent further redirects
        if (!to.query.conversationId && !to.query.type) {
            return;
        }
        return navigateTo({
            path: to.path, // Preserve path
            query: {}      // Remove query parameters
        }, { replace: true }); // Use replace to avoid extra history entry
    }
    if(to.name === 'UserDashboard' && to.meta.layout === 'admin' && isAuthenticated.value && user.value.adminFor && !to.query.switchClub){
        if(user.value.adminFor.length === 1){
            return navigateTo({
                name : 'ClubDashboard',
                params : {
                    clubId : user.value.adminFor[0]
                }
            })
        }
    }

    // X222 (R91 O-2): /conversations/{id} is redirected by its own page middleware (auth first, then a 301), not
    // here: a global middleware runs before the page's, so it 302'd and skipped the sign-in check.

});
